import React from 'react';
import { Card, CardContent, Skeleton, Box } from '@mui/material';

export default function TicketDetailSkeleton() {
  return (
    <Box>
      <Skeleton variant="text" width="40%" height={40} />
      <Box sx={{ display: 'flex', gap: 1, my: 1 }}>
        <Skeleton variant="rounded" width={80} height={24} />
        <Skeleton variant="rounded" width={100} height={24} />
      </Box>
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Skeleton variant="text" />
          <Skeleton variant="text" />
          <Skeleton variant="text" width="60%" />
        </CardContent>
      </Card>
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Skeleton variant="text" width={120} />
          <Skeleton variant="rectangular" height={60} sx={{ mt: 1 }} />
          <Skeleton variant="rectangular" height={60} sx={{ mt: 1 }} />
        </CardContent>
      </Card>
    </Box>
  );
}
